import { Directive, OnInit, Input, HostBinding } from '@angular/core';

@Directive({
    selector: '[imgPreloader]',
})
export class ImagePreloaderDirective implements OnInit {
    @Input('imgPreloader') public imgPreloader: string;
    @Input() public loadingImage: string = 'assets/images/loader.gif';
    @Input() public noImage: string = 'assets/img/no-image.svg';
    @HostBinding('attr.src') public finalImage: any;
    public downloadingImage: any;

    public ngOnInit() {
        this.finalImage = this.loadingImage;
        if (!this.imgPreloader) {
            this.finalImage = this.noImage;
            return;
        }

        this.downloadingImage = new Image();
        this.downloadingImage.onload = () => {
            this.finalImage = this.imgPreloader;
        };

        this.downloadingImage.onerror = () => {
            this.finalImage = this.noImage;
        };

        this.downloadingImage.src = this.imgPreloader;
    }
}



// WEBPACK FOOTER //
// ./src/shared/module/common/directives/image-preloader.directive.ts